module.exports = __webpack_public_path__ + "media/images/lp/1/voice2-close-7775b4e1ede98ad3a1bb6d925e8c7d53.png";